import { Amplify } from 'aws-amplify'
import { env } from '@/config/env'

// Configure Amplify
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: env.cognitoUserPoolId,
      userPoolClientId: env.cognitoClientId,
      loginWith: {
        // Enable username/password auth
        username: true,
        // Configure OAuth/Social providers
        oauth: {
          domain: env.cognitoDomain,
          scopes: [
            'openid',
            'profile',
            'email',
            'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: [env.redirectSignIn],
          redirectSignOut: [env.redirectSignOut],
          responseType: 'code' as const,
        },
      },
    },
  },
  ssr: true,
}

Amplify.configure(amplifyConfig)

export default amplifyConfig
